var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTariffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37109 1.86035C8.24475 1.51351 7.75525 1.51351 7.62891 1.86035L6.18555 5.82715L6.08984 6.08984L5.82715 6.18555L1.86035 7.62891C1.51351 7.75525 1.51351 8.24475 1.86035 8.37109L5.82715 9.81445L6.08984 9.91016L6.18555 10.1729L7.62891 14.1396C7.75525 14.4865 8.24475 14.4865 8.37109 14.1396L9.81445 10.1729L9.91016 9.91016L10.1729 9.81445L14.1396 8.37109C14.4865 8.24475 14.4865 7.75525 14.1396 7.62891L10.1729 6.18555L9.91016 6.08984L9.81445 5.82715L8.37109 1.86035Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTariffIcon);
export default __webpack_public_path__ + "static/media/menu-tariff-icon.b1432c2b24481aa208c71e3fa406aaf3.svg";
export { ForwardRef as ReactComponent };